import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  HostListener,
} from "@angular/core";
import { ROUTES } from "./vertical-menu-routes.config";
import { HROUTES } from "../horizontal-menu/navigation-routes.config";

import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { customAnimations } from "../animations/custom-animations";
import { DeviceDetectorService } from "ngx-device-detector";
import { ConfigService } from "../services/config.service";
import { Subscription } from "rxjs";
import { LayoutService } from "../services/layout.service";
import Me, { User } from "../../helpers/me";
import { take } from "rxjs/operators";
import { ADMINROUTES } from "./vertical-menu-routes-admin.config";
import { CONFERIDORROUTES } from "./vertical-menu-routes-conferidor.config";
import { JwtHelper } from "../../helpers/jwt-helper";

@Component({
  selector: "app-sidebar",
  templateUrl: "./vertical-menu.component.html",
  animations: customAnimations,
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("toggleIcon") toggleIcon: ElementRef;
  public menuItems: any[];
  level: number = 0;
  logoUrl = "assets/img/logo.png";
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;
  user = null;
  isConferidor = false;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private me: Me,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }

  async ngOnInit() {
    const self = this;
    self.menuItems = [];
    const dadosUsuario = self.me.currentUserValue;
    const json = JSON.parse(JSON.stringify(dadosUsuario));
    self.user = json.user;
    console.log(json.user);
    
    // Verifica se é conferidor através do token JWT
    self.isConferidor = json.token && JwtHelper.isConferidor(json.token);
    
    if (self.isConferidor) {
      this.menuItems = CONFERIDORROUTES;
    } else if (json.user && json.user.tipo === "1") {
      this.menuItems = ADMINROUTES;
    } else {
      this.menuItems = ROUTES;
      this.PermissaoSimuladorESapiem(dadosUsuario);
    }

  }

  private PermissaoSimuladorESapiem(dadosUsuario: User) {
       // adiciona simulador
    if (dadosUsuario.permissao?.some((perm) => perm.id_modulo === 2)) {
      if (!this.menuItems.find((x) => x.title === "Simulador Aposentadoria")) {
        this.menuItems.push({
          path: "/page/servidor/simulador",
          title: "Simulador Aposentadoria",
          icon: "ft-dollar-sign",
          class: "",
          badge: "",
          badgeClass: "",
          isExternalLink: false,
          submenu: [],
        });
      }
    } else {
      // remove simulador se existir
      this.menuItems = this.menuItems.filter(
        (item) => item.title !== "Simulador Aposentadoria"
      );
    }

    // SAPIEM removido do menu lateral - agora acessível apenas via menu de acesso rápido do admin
  }

  ngAfterViewInit() {
    const self = this;
    const dadosUsuario = self.me.currentUserValue;
    this.PermissaoSimuladorESapiem(dadosUsuario);

    this.configSub = this.configService.templateConf$.subscribe(
      (templateConf) => {
        if (templateConf) {
          this.config = templateConf;
        }
        this.loadLayout();
        this.cdr.markForCheck();
      }
    );

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      (collapse) => {
        if (this.config.layout.menuPosition === "Side") {
          this.collapseSidebar = collapse;
        }
      }
    );
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize(event) {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout(
      (() => {
        this.innerWidth = event.target.innerWidth;
        this.loadLayout();
      }).bind(this),
      500
    );
  }

  loadLayout() {
    if (this.config.layout.menuPosition === "Top") {
      // Horizontal Menu
      if (this.innerWidth < 1200) {
        // Screen size < 1200
        this.menuItems = HROUTES;
      }
    } else if (this.config.layout.menuPosition === "Side") {
      // Vertical Menu{
      const dadosUsuario = this.me.currentUserValue;
      const json = JSON.parse(JSON.stringify(dadosUsuario));
      
      // Verifica se é conferidor através do token JWT
      this.isConferidor = json.token && JwtHelper.isConferidor(json.token);
      
      if (this.isConferidor) {
        this.menuItems = CONFERIDORROUTES;
      } else if (json.user && json.user.tipo === "1") {
        this.menuItems = ADMINROUTES;
      } else {
        this.menuItems = ROUTES;
      }
    }
    if (this.config.layout.sidebar.backgroundColor === "white") {
      this.logoUrl = "assets/img/logo-dark.png";
    } else {
      this.logoUrl = "assets/img/logo.png";
    }

    if (this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    } else {
      this.collapseSidebar = false;
    }
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({ layout: conf.layout });

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    } else {
      this.perfectScrollbarEnable = true;
    }
  }

  ngOnDestroy() {
    this.menuItems = [];
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }
  }
}
